package io.github.jangalinski.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initIndexPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("index.md", FrontMatterElement.Builder { addScalar("title", "Jan Galinski"); addScalar("description", "A developers logbook"); addScalar("header-img", "/img/home-bg.jpg"); }))
}

@Page("/")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun IndexPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Welcome back. This is the revived version of the old GitHub Pages blog, now rendered with Kobweb.")
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("posts") }) {
        org.jetbrains.compose.web.dom.Text("Posts")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2016/10/06/osx-idea-external-editor") {
                org.jetbrains.compose.web.dom.Text("Using external editors in IDEA/OSX")
            }
            org.jetbrains.compose.web.dom.Text(" - once and for all open your files in the system default editor")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2016/09/15/and-the-winner-is") {
                org.jetbrains.compose.web.dom.Text("Camunda Community Award 2016")
            }
            org.jetbrains.compose.web.dom.Text(" - and the winner is .... me :-)")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2016/04/05/idea-ultimate-on-osx") {
                org.jetbrains.compose.web.dom.Text("Intellij Idea Ultimate on OSX El Capitan")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2016/03/25/matching-collector") {
                org.jetbrains.compose.web.dom.Text("Java8-Stream Collect BestMatch for given condition")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2015/10/05/buzzword-clock") {
                org.jetbrains.compose.web.dom.Text("Building a BuzzwordClock with Reactor, Atmosphere, Spring-Boot and Vaadin")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2015/07/27/convert-from-camel-to-snake-case") {
                org.jetbrains.compose.web.dom.Text("Convert test method names from camelCase to snake_case")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2015/02/28/deploy-springboot-as-war") {
                org.jetbrains.compose.web.dom.Text("Dual build springboot jar and war")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/12/29/easy-mysql-setup-with-docker") {
                org.jetbrains.compose.web.dom.Text("Easy MySQL setup with docker")
            }
            org.jetbrains.compose.web.dom.Text(" - EasyMysql makes your life ... easy")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/12/08/streaming-from-dropbox") {
                org.jetbrains.compose.web.dom.Text("Streaming from dropbox")
            }
            org.jetbrains.compose.web.dom.Text(" - Build a little mans youtube")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/10/19/osx-yosemite") {
                org.jetbrains.compose.web.dom.Text("My new yosemite")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/09/30/starting-with-dropwizard") {
                org.jetbrains.compose.web.dom.Text("Starting with dropwizard")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/09/23/redirect-git-remotes") {
                org.jetbrains.compose.web.dom.Text("Redirect to new github location")
            }
            org.jetbrains.compose.web.dom.Text(" - nice to know")
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/2014/09/19/clone-all-github-repos-of-an-organization") {
                org.jetbrains.compose.web.dom.Text("Clone all github repos of an organization")
            }
            org.jetbrains.compose.web.dom.Text(" - sometimes you need just everything at once")
        }
    }
    org.jetbrains.compose.web.dom.H2(attrs = { id("more") }) {
        org.jetbrains.compose.web.dom.Text("More")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/about") {
                org.jetbrains.compose.web.dom.Text("About")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/links") {
                org.jetbrains.compose.web.dom.Text("Links")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("https://github.com/jangalinski") {
                org.jetbrains.compose.web.dom.Text("GitHub profile")
            }
        }
    }
}
